import React from 'react';
import { Phone } from 'lucide-react';
import { siteData } from '../data';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import Contact from '../components/Contact';

function Home() {
  return (
    <>
      <Hero />
      <Services />
      <About />
      <Contact />
      
      {/* Mobile Sticky Call Button */}
      <div className="md:hidden fixed bottom-6 right-6 z-40">
        <a
          href={`tel:${siteData.phone}`}
          className="flex items-center justify-center w-14 h-14 bg-amber-500 text-white rounded-full shadow-2xl animate-bounce"
        >
          <Phone className="w-6 h-6" />
        </a>
      </div>
    </>
  );
}

export default Home;
